import * as type from "./type";

export const initialState = {
  isLoading: false,
  isSecondaryLoading: false,
  isSuccess: false,
  details: {},
  relatedProductByCategoryList: [],
  variantValue: [],
  shoppingCart: null,
  questionAndAnswerList: [],
  questionAndAnswerListByUser: [],
  questionCount: {},

  productOfferList: [],
  save_qa_id: 0,
};

/**
 * @param action
 */
const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case type.START_LOADING:
      return {
        ...getCommonState(state),
        isLoading: true,
      };
    case type.STOP_LOADING:
      return {
        ...getCommonState(state),
      };
    case type.START_SECONDARY_LOADING:
      return {
        ...getCommonState(state),
        isSecondaryLoading: true,
        isSuccess: false,
      };
    case type.STOP_SECONDARY_LOADING:
      return {
        ...getCommonState(state),
      };
    case type.IS_SUCCESS:
      return {
        ...getCommonState(state),
        isSuccess: action.payload,
      };
    case type.PRODUCT_DETAILS:
      return {
        ...getCommonState(state),
        details: action.payload,
      };
    case type.CLEAR_PRODUCT_DETAILS:
      return initialState;
    case type.RELATED_PRODUCT_BY_CATEGORY:
      return {
        ...getCommonState(state),
        relatedProductByCategoryList: action.payload,
      };
    case type.GET_VARIANT_VALUE:
      return {
        ...getCommonState(state),
        variantValue: action.payload,
      };
    case type.GET_CART_DETAIL:
      return {
        ...getCommonState(state),
        shoppingCart: action.payload,
      };
    case type.GET_Q_AND_A_LIST:
      return {
        ...getCommonState(state),
        questionAndAnswerList: action.payload,
      };
    case type.GET_Q_AND_A_LIST_BY_USER:
      return {
        ...getCommonState(state),
        questionAndAnswerListByUser: action.payload,
      };
    case type.GET_QUESTION_COUNT:
      return {
        ...getCommonState(state),
        questionCount: action.payload,
      };
    case type.GET_TERMS:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.GET_SHIPPING:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.GET_WARRANTY:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.GET_POLICY:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.GET_PREORDER:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.GET_INSTALLATION:
      return {
        ...getCommonState(state),
        productOfferList: action.payload,
      };
    case type.SAVE_QA_ID: {
      return {
        ...getCommonState(state),
        save_qa_id: action.payload,
      };
    }
    default:
      return state;
  }
};
export default Reducer;

const getCommonState = (state) => ({
  ...state,
  isLoading: false,
  isSecondaryLoading: false,
  dataExist: true,
});

/**
 * Action
 */
export const set_start_loading = () => ({
  type: type.START_LOADING,
});

export const set_stop_loading = () => ({
  type: type.STOP_LOADING,
});

export const set_start_secondary_loading = () => ({
  type: type.START_SECONDARY_LOADING,
});

export const set_stop_secondary_loading = () => ({
  type: type.STOP_SECONDARY_LOADING,
});

export const set_is_success = (data) => ({
  type: type.IS_SUCCESS,
  payload: data,
});

export const set_details = (data = {}) => ({
  type: type.PRODUCT_DETAILS,
  payload: data,
});

export const set_variant_value = (data = []) => ({
  type: type.GET_VARIANT_VALUE,
  payload: data,
});
